import { DEDUCTIBLE_INFO, LIABILITY_CONSTANTS } from '@flows/configs/shared/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const liability_deductibles = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('deductible_amount')]:
        BaseSchema_LiabilityV1GetsafeDe.shape.deductible_amount,
    }),
    stepContent: [
      {
        type: 'title',
        text: { type: 'translatableText', translationKey: 'sharedFlows_common:steps.deductibles' },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('deductible_amount'),
        options: LIABILITY_CONSTANTS.deductiblesOptions.map((option) => {
          return {
            label: {
              type: 'nonTranslatableText',
              text: params.clientHelpers.formatter.formatCurrency(option),
            },
            value: Number(option),
          }
        }),
      },
      DEDUCTIBLE_INFO(),
    ],
    subFlow: params.subFlow,
    nextStep: 'liability_previously_owned',
  }) as const satisfies AnyStepConfiguration

export default liability_deductibles
